export const LABOR_VITALS_ROOT_LINK_ID = "laborVitals";

export const LABOR_VITALS_DATE_TIME_LINK_ID = "vitalDateTime";
export const LABOR_VITALS_DATE_LINK_ID = "vitalDate";
export const LABOR_VITALS_TIME_LINK_ID = "vitalTime";

export const LABOR_VITALS_BLOOD_PRESSURE_LINK_ID = "bloodPressure";
export const LABOR_VITALS_SYSTOLIC_LINK_ID = "systolic";
export const LABOR_VITALS_DIASTOLIC_LINK_ID = "diastolic";

export const LABOR_VITALS_PULSE_LINK_ID = "pulse";

export const LABOR_VITALS_TEMPERATURE_LINK_ID = "temperature";
export const LABOR_VITALS_TEMPERATURE_VALUE_LINK_ID = "temperatureValue";
export const LABOR_VITALS_TEMPERATURE_UNIT_LINK_ID = "temperatureUnit";

export const LABOR_VITALS_METHOD_LINK_ID = "method";
export const LABOR_VITALS_NOTES_LINK_ID = "notes";
export const LABOR_VITALS_SIGNATURE_INITIALS_LINK_ID = "signatureInitials";

export const LABOR_VITALS_QUESTIONNAIRE_NAME = "labor_vitals";
